import { Logger } from 'lib/logger.js';

class ReactLogger extends Logger {

	

}

export { ReactLogger }